import StateIndicator from './component'

export default StateIndicator
